/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Space,
  Form,
  Input,
  Switch,
  Row,
  Popconfirm,
  DatePicker
} from 'antd';
import { useTheme } from 'contexts/theme';
import { useDispatch, useSelector } from 'react-redux';
import AddForm from './AddForm';
import {
  EditOutlined,
  DeleteOutlined,
  SaveOutlined,
  UndoOutlined,
  FolderOpenFilled
} from '@ant-design/icons';
import Dropdown from 'components/Dropdown';
import moment from 'moment';
import InputTag from 'components/InputTag';

interface RegionEditProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: any;
  inputType: 'number' | 'text';
  record: any;
  index: number;
  children: React.ReactNode;
  dataSource: any;
  label: string;
  valueKey: string;
  allOptionName: string;
  isSwitch: boolean;
  mode?: string;
}

interface filterType {
  [key: string]: any;
}

const MasterTable = ({
  onSave,
  onEdit,
  onDelete,
  reset,
  listData,
  columnData,
  formFields,
  filterFields,
  isLoading,
  pagination
}: {
  onSave: any;
  onEdit?: any;
  onDelete: any;
  reset: any;
  listData: any;
  columnData: any;
  formFields: any;
  filterFields?: any;
  isLoading?: boolean;
  pagination?: any;
}) => {
  const { dark } = useTheme();
  const dispatch = useDispatch();
  const [editingKey, setEditingKey] = useState('');
  const [filter, setFilter] = useState<filterType>();
  const [filteredList, setFilteredList] = useState();

  const isEditing = (record: any) => {
    return record.id === editingKey;
  };

  const [form] = Form.useForm();
  const [save] = onSave();
  let edit: any;
  if (onEdit) {
    [edit] = onEdit();
  }

  useEffect(() => {
    filterTable();
  }, [filter, listData]);

  const editOperation = (record: any & { key: React.Key }) => {
    form.setFieldsValue({ ...record });
    setEditingKey(record.id);
  };

  async function handleSave(record: any) {
    const operation = edit || save;
    await operation({ ...record, ...form.getFieldsValue(true) });
    setEditingKey('');
  }

  const handleDelete = (id: any) => {
    onDelete(id);
  };

  function handleChange(name: string, value: any) {
    form.setFieldsValue({ [name]: value });
  }

  function filterData(data: { [x: string]: any }) {
    let filterResult = true;
    filter &&
      Object.keys(filter).forEach((fiterItem) => {
        let check;
        if (typeof filter[fiterItem] !== 'string') {
          check =
            data[fiterItem]
              .toUpperCase()
              .includes(filter[fiterItem].target.value.toUpperCase()) ||
            filter[fiterItem].target.value === '';
        } else {
          check =
            data[fiterItem] === filter[fiterItem] || filter[fiterItem] === '';
        }
        if (!check) {
          filterResult = check;
          return false;
        }
      });
    return filterResult;
  }

  function filterTable() {
    const filteredList =
      listData && listData.filter((item: any) => filterData(item));
    setFilteredList(filteredList);
  }

  function handleFilterChange(name: string, value: any) {
    setFilter({
      ...filter,
      [name]: value
    });
  }

  function renderSwitch(name: string, status: string) {
    let isChecked, onChange;
    if (typeof status === 'boolean') {
      isChecked = status;
      onChange = (checked: boolean) => handleChange(name, checked);
    } else {
      let activeValue: string, inactiveValue: string;
      if (['active', 'inactive'].includes(status)) {
        activeValue = 'active';
        inactiveValue = 'inactive';
      } else {
        activeValue = 'true';
        inactiveValue = 'false';
      }
      isChecked = status === 'active' || status === 'true';
      onChange = (checked: boolean) =>
        handleChange(name, checked ? activeValue : inactiveValue);
    }
    return <Switch defaultChecked={isChecked} onChange={onChange} />;
  }

  const EditField: React.FC<RegionEditProps> = ({
    editing,
    dataIndex,
    title,
    record,
    index,
    children,
    dataSource,
    label,
    valueKey,
    allOptionName,
    isSwitch,
    ...restProps
  }) => {
    const renderField = () => {
      const field = formFields.find(
        (field: { name: string }) => field.name === dataIndex
      );
      const defaultDate = moment(record[dataIndex]);
      let matches;

      if (!(field || label || dataSource || isSwitch)) return null;

      if (field?.mulitiField) {
        const inputString = (record && record[dataIndex]);
        matches = inputString.match(/(\d+) (\w+)/);
      }

      return (
        <Form.Item
          key={dataIndex}
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: true,
              message: `Enter ${title}`
            }
          ]}
        >
          {console.log(record[dataIndex], "record")}
          {dataSource || (field && field.dataSource) && field.mulitiField !== true ? (
            <Dropdown
              onChange={(value: any) => handleChange(dataIndex, value)}
              dataSource={dataSource || (field && field.dataSource)}
              defaultValue={record && record[dataIndex]}
              placeholder={label || (field && field.label)}
              valueKey={valueKey || (field && field.valueKey)}
              mode={field?.mode && field?.mode}
              allOptionName={allOptionName || (field && field.allOptionName)}
              style={{ width: 180 }}
            />
          ) : field?.mode == "inputTag" ? (
            <InputTag
              onChange={(value: any) => handleChange(dataIndex, value)}
              dataSource={[]}
              placeholder={field?.label}
              defaultValue={record && record[dataIndex]}
              valueKey={field?.valueKey}
              allOptionName={field?.allOptionName}
              style={{ width: 180 }}
            />
          ) : isSwitch || field.status != undefined ? (
            renderSwitch(dataIndex, record[dataIndex])
          )
            : field?.date == true ? (
              <DatePicker defaultValue={defaultDate} />
            )
              : field?.mulitiField == true ? (
                <Space>
                  <Dropdown
                    onChange={(value: any) => handleChange(dataIndex, value)}
                    dataSource={field?.subSource}
                    defaultValue={record && parseInt(matches[1], 10)}
                    valueKey={field?.valueKey}
                    allOptionName={field?.allOptionName}
                  />
                  <Dropdown
                    onChange={(value: any) => handleChange(dataIndex, value)}
                    dataSource={field?.dataSource}
                    placeholder={field?.label}
                    defaultValue={record && matches[2]}
                    valueKey={field?.valueKey}
                    mode={field?.mode && field?.mode}
                    allOptionName={field?.allOptionName}
                  />
                </Space>
              )
                : (
                  <Input placeholder={field.label} type="text" onChange={(e: any) => handleChange(dataIndex, e.target.value)} defaultValue={record && record[dataIndex]} />
                )}
        </Form.Item>
      );
    };

    return <td {...restProps}>{editing ? renderField() : children}</td>;
  };
  const shouldShowCloneColumn = columnData?.some((item) => item?.clone === true);
  const columns = [
    ...columnData,
    {
      title: 'Edit',
      key: 'edit',
      render: (_: any, record: any) => {
        const editable = isEditing(record);
        return editable ? (
          <Space>
            <Button
              icon={<SaveOutlined />}
              className="save-icon"
              shape="circle"
              type="primary"
              htmlType="submit"
              onClick={() => handleSave(record)}
            />
            <Button
              icon={<UndoOutlined />}
              className="delete-icon"
              shape="circle"
              type="primary"
              onClick={() => setEditingKey('')}
            />
          </Space>
        ) : (
          <Button
            icon={<EditOutlined />}
            className="edit-icon"
            shape="circle"
            type="primary"
            onClick={() => editOperation(record)}
          />
        );
      }
    },
    {
      title: 'Delete',
      key: 'delete',
      dataIndex: 'id',
      render: (id: any) => (
        <Popconfirm
          placement="topLeft"
          title="Are you sure you want to delete the entry?"
          onConfirm={() => handleDelete(id)}
          okText="Yes"
          cancelText="No"
        >
          <Button
            icon={<DeleteOutlined />}
            className="delete-icon"
            shape="circle"
            type="primary"
          />
        </Popconfirm>
      )
    },
    shouldShowCloneColumn
      ? {
        title: 'Clone',
        key: 'clone',
        dataIndex: 'id',
        render: (id: any) => (
          <Button
            icon={<FolderOpenFilled />}
            className="clone-icon"
            shape="circle"
            type="primary"
          />
        ),
      }
      : {},
  ];

  const mergedColumns = columns.map((col) => {
    console.log(col, "col")
    if (!col.editable) {
      return col;
    }
    //     return {
    //   ...col,
    //   // sortDirections: ['descend', 'ascend'],
    //   // sorter: (a, b) => a[col?.dataIndex]?.localeCompare(b[col?.dataIndex]),
    //   onCell: (record: any) => ({
    //     record,
    //     ...col,
    //     editing: isEditing(record)
    //   })
    // };
    const columnWithSorter = {
      ...col,
      onCell: (record: any) => ({
        record,
        ...col,
        editing: isEditing(record)
      })
    };

    if ((!col?.render || col?.editable && col?.dataIndex) && col?.sorter !== false) {
      // Add sorter only if col.render is not defined
      console.log(columnWithSorter, "abbb"),
        columnWithSorter.sorter = (a, b) =>

          a[col?.dataIndex]?.localeCompare(b[col?.dataIndex]);
      columnWithSorter.sortDirections = ['descend', 'ascend']
    }

    return columnWithSorter;
  });

  return (
    <>
      <Row justify="start" style={{ marginBottom: 10 }}>
        {filterFields &&
          filterFields.map(
            (field: {
              valueKey: string;
              dataSource: any;
              defaultValue: string;
              name: string;
              label: string;
              allOptionName: string | undefined;
              mode?: string;
              showSearch: boolean | undefined
            }) =>
              field.dataSource ? (
                <Dropdown
                  key={field.valueKey}
                  {...(field.mode ? { mode: field.mode } : {})}
                  onChange={(value: any) =>
                    handleFilterChange(field.name, value)
                  }
                  dataSource={field.dataSource}
                  defaultValue={field.defaultValue}
                  valueKey={field.valueKey}
                  allOptionName={field.allOptionName}
                  style={{ width: 180 }}
                  showSearch={field?.showSearch}
                />
              ) : (
                <Input
                  key={field.name}
                  onChange={(event: any) =>
                    handleFilterChange(field.name, event)
                  }
                  placeholder={field.label}
                />
              )
          )}
      </Row>
      <Form form={form} component={false}>
        <Table
          components={{
            body: {
              cell: EditField
            }
          }}
          scroll={{ x: 'max-content' }}
          loading={isLoading}
          pagination={pagination}
          dataSource={filteredList}
          columns={mergedColumns}
          className={dark ? 'table-dark' : 'table-light'}
          footer={() => <AddForm onSave={onSave} formFields={formFields} />}
        />
      </Form>
    </>
  );
};

export default MasterTable;
